import { TableProvider, useTableState } from '@optimus-web/core';
import { PortfolioCentralCancellationPolicyOverviewEntry } from '@mews-commander/data-access';
import { SuspenseBoundary } from '@mews-commander/ui';
import { CancellationPolicyTableContent } from './CancellationPolicyTableContent';
import { columns } from './columns';

export const CancellationPolicyTable = () => {
    const [tableState, setTableState] = useTableState<PortfolioCentralCancellationPolicyOverviewEntry>();
    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
            <SuspenseBoundary>
                <CancellationPolicyTableContent tableState={tableState} />
            </SuspenseBoundary>
        </TableProvider>
    );
};
